'use client';

import { useState, useEffect } from 'react';
import { NextIntlClientProvider } from 'next-intl';
import { Providers } from './provider';
import { useSearchParams, usePathname } from 'next/navigation';
import enMessages from '@/messages/en.json';
import faMessages from '@/messages/fa.json';
import frMessages from '@/messages/fr.json';
import Cookies from "js-cookie";

const messagesMap = {
    en: enMessages,
    fa: faMessages,
    fr: frMessages
};

export default function ClientLocaleWrapper({ children }: { children: React.ReactNode }) {

    const searchParams = useSearchParams();
    const pathname = usePathname();

    const [locale, setLocale] = useState(() => {
        if (typeof window !== 'undefined') {
            return Cookies.get('language') || 'en';
        }
        return 'en';
    });

    useEffect(() => {
        const isConsultation = pathname?.indexOf('/consultation') !== -1;
        const supportedLangs = isConsultation ? ['en', 'fa', 'fr'] : ['en', 'fr'];
        
        const langParam = searchParams?.get('lang');
        
        if (langParam && supportedLangs.includes(langParam)) {
            Cookies.set('language', langParam);
            setLocale(langParam);
        } else {
            const currentLang = Cookies.get('language') || 'en';
            
            if (!supportedLangs.includes(currentLang)) {
                Cookies.set('language', 'en');
                setLocale('en');
            } else {
                setLocale(currentLang);
            }
        }
    }, [searchParams, pathname]);

    const messages = locale in messagesMap ? messagesMap[locale as keyof typeof messagesMap] : messagesMap['en'];

    return (
        <NextIntlClientProvider locale={locale} messages={messages}>
            <Providers>{children}</Providers>
        </NextIntlClientProvider>
    );
};
